import { render, staticRenderFns } from "./ModalPopupForm.vue?vue&type=template&id=45384ab5&scoped=true"
import script from "./ModalPopupForm.vue?vue&type=script&lang=js"
export * from "./ModalPopupForm.vue?vue&type=script&lang=js"
import style0 from "./ModalPopupForm.vue?vue&type=style&index=0&id=45384ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45384ab5",
  null
  
)

export default component.exports